export default {
  "content": "<path d=\"M12.5 16l5.5-5.5L12.5 5l-1.062 1.062 3.687 3.688H2v1.5h13.125l-3.687 3.688L12.5 16z\" fill=\"currentColor\"/>",
  "attrs": {
    "width": "20",
    "height": "20",
    "viewBox": "0 0 20 20",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};